export class Address {
    Country?: string;
    City?: string;
    Street?: string;
    Number?: string;
}
